<template>
  <div class="text-with-image__container">
    <div class="text-with-image__content">
      <div class="text-with-image__content-text">
        <Heading size="h2">
          {{ title }}
        </Heading>
        <Paragraph size="large" is-without-margin>
          <i18n
            :path="descriptionKey"
          >
            <template v-for="(placeholder, index) in Object.keys($t(linksKey))" #[placeholder]>
              <Link :key="index" :href="urls[placeholder]" target="_blank">
                <span>{{ $t(linksKey)[placeholder] }}</span>
              </Link>
            </template>
            <template #br>
              <br>
            </template>
          </i18n>
        </Paragraph>
        <RssUiButton
          v-if="buttonText"
          class="text-with-image__content-text-button lp-button"
          :href="buttonUrl"
          :blank="true"
          rainbow
        >
          {{ buttonText }}
        </RssUiButton>
      </div>
      <img
        class="text-with-image__content-image"
        :src="imagePath"
        :srcset="`${imagePath.replace(/(\.png)$/, '@2x$1')} 2x`"
        :alt="imageAlt"
      >
    </div>
  </div>
</template>

<script>
import Heading from '@/components/common/Heading/Heading'
import Paragraph from '@/components/common/Paragraph/Paragraph'
import Link from '@/components/common/Link/Link'

export default {
  components: {
    Heading,
    Paragraph,
    Link
  },
  props: {
    title: {
      type: String,
      required: true
    },
    descriptionKey: {
      type: String,
      required: true
    },
    linksKey: {
      type: String,
      default: null
    },
    urls: {
      type: Object,
      default: () => {}
    },
    imagePath: {
      type: String,
      required: true
    },
    imageAlt: {
      type: String,
      default: null
    },
    buttonText: {
      type: String,
      default: null
    },
    buttonUrl: {
      type: String,
      default: ''
    }
  }

}
</script>

<style lang="scss" scoped>
.text-with-image {
  &__container {
    padding-left: $gap;
    background-color: #201136;

    @include display-less(desktop) {
      padding-left: 0;
    }
  }

  &__content {
    max-width: 1120px;
    margin: 0 auto;
    display: flex;
    align-items: center;

    gap: $gap * 2;
    flex-direction: row;

    @include display-less(desktop) {
      flex-direction: column;
    }

    &-text {
      display: flex;
      flex-direction: column;
      gap: $gap * 2;
      margin: $gap * 3.5 0;

      @include display-less(desktop) {
        margin: $gap * 5 $gap 0 $gap;
      }

      &-button {
        width: fit-content;
        font-weight: bold;
        height: 10px;

        @include display-less(desktop) {
          width: 100%;
        }
      }
    }

    &-image {
      max-width: 650px;

      @include display-less(hd) {
        max-width: 530px;
      }

      @include display-less(desktop) {
        max-width: 650px;
        width: 100%;
      }
    }
  }
}
</style>
